import api from "@/config/api";
import type { RequestOptions } from "@/shared/types/api.types";
import { API_ENDPOINTS } from "@/constants/api-endpoints";
import type { PageResponseDTO } from "@/shared/types/pagination.types";
import type {
  RentalDetailResponseDTO,
  DevolutionSearchParams,
  RentalReturnPayloadDTO,
} from "../types/devolution.types";

export const devolutionService = {
  searchRentals: async (
    params: DevolutionSearchParams,
  ): Promise<PageResponseDTO<RentalDetailResponseDTO>> => {
    const response = await api.get<PageResponseDTO<RentalDetailResponseDTO>>(
      API_ENDPOINTS.RENTALS.SEARCH,
      { params },
    );
    return response.data;
  },

  getById: async (
    id: number,
    options?: RequestOptions,
  ): Promise<RentalDetailResponseDTO> => {
    const response = await api.get<RentalDetailResponseDTO>(
      API_ENDPOINTS.RENTALS.BY_ID(id),
      { signal: options?.signal },
    );
    return response.data;
  },

  returnRental: async (
    id: number,
    payload: RentalReturnPayloadDTO,
  ): Promise<void> => {
    await api.post(API_ENDPOINTS.RENTALS.RETURN(id), payload);
  },
};
